import { ReactComponent as GoogleIcon } from "@src/assets/googleIcon.svg"

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  text?: string
}

const ButtonGoogle: React.FC<Props> = ({ text = "Sign in with Google", ...props }) => {
  return (
    <button
      className="flex items-center mx-auto w-[200px] gap-3 rounded-lg bg-[#1A73E8] p-1 text-sm disabled:opacity-50 select-none text-white"
      {...props}
    >
      <div className="flex items-center justify-center bg-white p-2 rounded">
        <GoogleIcon style={{ width: "20px", height: "20px" }} />
      </div>
      <div className="text-center flex-1">{text}</div>
    </button>
  )
}

export default ButtonGoogle
